module.exports = __webpack_public_path__ + "officialStatic/img/sjb.a642363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/sjb.png
// module id = L5Zl
// module chunks = 0